import { Col, Row } from '@elotech/components';
import React from 'react';

import { useCamposLocalizacao } from '../../hooks/useCamposLocalizacao';
import { CadastroImobiliario } from '../../type';
import { CampoLocalizacao } from '../../utils/InscricaoCadastralUtils';

type Props = {
  cadastroImobiliario: CadastroImobiliario;
  desconsideraAreaConstruida?: boolean;
  /** Campos de localização já carregados pela tela; sem eles, o componente carrega a configuração. */
  camposLocalizacao?: CampoLocalizacao[];
};

const PropriedadeUrbanoQuickView: React.FC<Props> = ({
  cadastroImobiliario,
  desconsideraAreaConstruida,
  ...props
}) => {
  const camposLocalizacao = useCamposLocalizacao(props.camposLocalizacao);

  return (
    <>
      <div className="quick-header">Propriedade</div>
      <Row>
        <Col md={12}>
          <div className="form-group">
            <label className="label">Proprietário</label>
            {cadastroImobiliario?.proprietario}
          </div>
        </Col>
      </Row>
      <Row>
        {camposLocalizacao.map(({ campo, label, campoCadastro }) => (
          <Col md={4} key={campo}>
            <div className="form-group">
              <label className="label">{label}</label>
              {cadastroImobiliario?.[campoCadastro]}
            </div>
          </Col>
        ))}
      </Row>
      <Row>
        <Col md={4}>
          <div className="form-group">
            <label className="label">Área Terreno</label>
            {cadastroImobiliario?.areaTerreno
              ? `${cadastroImobiliario?.areaTerreno} m²`
              : ''}
          </div>
        </Col>
        <Col md={4}>
          <div className="form-group">
            <label className="label">Área Construída</label>
            {cadastroImobiliario?.areaConstruida &&
            desconsideraAreaConstruida !== true
              ? `${cadastroImobiliario?.areaConstruida} m²`
              : ''}
          </div>
        </Col>
      </Row>
      {cadastroImobiliario?.condominio && (
        <Row>
          <Col md={12}>
            <div className="form-group">
              <label className="label">Condomínio</label>
              {`${cadastroImobiliario.condominio} - ${cadastroImobiliario.descricaoCondominio}`}
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};

export default PropriedadeUrbanoQuickView;
